var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlockAction(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2270_2219)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.49998 0C3.36001 0 0 3.36001 0 7.49998C0 11.64 3.36001 15 7.49998 15C11.64 15 15 11.64 15 7.49998C15 3.36001 11.64 0 7.49998 0ZM2.11999 7.49998C2.11999 4.51999 4.53998 2.1 7.49998 2.1C8.61999 2.1 9.68 2.44001 10.54 3.03999L3.06001 10.54C2.46 9.68 2.11999 8.61999 2.11999 7.49998ZM7.49998 12.88C6.37998 12.88 5.31997 12.54 4.46 11.94L11.94 4.46C12.54 5.32 12.88 6.37998 12.88 7.49998C12.88 10.48 10.48 12.88 7.49998 12.88Z",
    fill: "#D15241"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2270_2219"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockAction);
export default __webpack_public_path__ + "static/media/block-action.3964b440c0b3fdada8f480ca63c68edf.svg";
export { ForwardRef as ReactComponent };